import { ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { onRNMessage } from '@/bridge/fromRN'
import { currentSubUserId } from '@/stores/chat'

export interface ImToastState {
  visible: boolean
  senderId: number | null
  senderName: string
}

/**
 * 全局 IM 透传 Toast。
 *
 * 订阅 RN 转发的 pushMessage({bizType, bizData});对 bizType==='im' 的消息,
 * 仅当用户在当前子账号聊天页时跳过(由 useChatMessages 直接加载),其余弹顶部 Toast。
 * 点击 → pushWebViewToRN 压新 WebView 加载该子账号聊天页(原页保留,返回回原,不覆盖当前聊天)。
 * App.vue setup 调用,根组件常驻不卸载。
 */
export function useImNotify() {
  const route = useRoute()
  const toastState = ref<ImToastState>({ visible: false, senderId: null, senderName: '' })
  let timer: number | undefined

  function showToast(senderId: number, senderName: string) {
    if (timer) clearTimeout(timer)
    toastState.value = { visible: true, senderId, senderName }
    timer = window.setTimeout(() => {
      toastState.value.visible = false
    }, 3000)
  }
  function hideToast() {
    if (timer) clearTimeout(timer)
    toastState.value.visible = false
  }
  const router = useRouter()
  function onClick() {
    const { senderId, senderName } = toastState.value
    hideToast()
    if (senderId != null) {
      router.push({ name: 'chat', params: { subUserId: senderId }, query: { nickName: senderName ?? '' } })
    }
  }

  onRNMessage('pushMessage', (msg) => {
    const payload = msg.payload
    if (payload?.bizType !== 'im') return
    const { senderId, senderName } = payload.bizData ?? {}
    if (senderId == null) return
    // 当前子账号聊天页:交给 useChatMessages 直接加载,不弹 Toast
    if (route.name === 'chat' && currentSubUserId.value === senderId) return
    showToast(senderId, senderName ?? '')
  })

  return { toastState, onClick, hideToast }
}
